import { forwardRef } from 'react';
import * as React from 'react';
import { Platform, View, ViewProps, ViewStyle } from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES, minSize } from 'rn-responsive-styles';

import { colors, spacing } from '../../theme';

export const DefaultLayout = forwardRef<View, Props>(
	({ children, view, bottomGutter, style, ...viewProps }, ref) => {
		const styles = useStyles();

		return (
			<View
				style={[
					styles.root,
					Platform.OS === 'web' && styles.web,
					view && styles.viewContainer,
					bottomGutter && styles.bottomGutter,
					style,
				]}
				{...viewProps}
				ref={ref}
			>
				{children}
			</View>
		);
	},
);

type Props = {
	children: React.ReactNode;
	view?: boolean;
	bottomGutter?: boolean;
	style?: ViewStyle;
} & ViewProps;

const useStyles = CreateResponsiveStyle(
	{
		root: {
			backgroundColor: colors.background,
			flex: 1,
		},
		viewContainer: {
			padding: spacing(2),
			justifyContent: 'flex-start',
			flexDirection: 'column',
			paddingTop: spacing(2.5),
		},
		bottomGutter: {
			paddingBottom: spacing(7),
		},
		web: {
			width: '100%',
			alignSelf: 'center',
			backgroundColor: 'transparent',
			alignItems: 'flex-start',
			overflowX: 'hidden',
		},
	},
	{
		[minSize(DEVICE_SIZES.MD)]: {
			web: {
				width: 768,
			},
		},
		[minSize(DEVICE_SIZES.LG)]: {
			web: {
				width: 1280,
				flexDirection: 'row',
				gap: spacing(4),
			},
		},
	},
);
